import TagManager from 'react-gtm-module';

export const phoneRegex = /^\+?[0-9()-]{7,}[0-9]$/;

/** Signup and settings use a 10-digit US number. Stored values may include a leading +1. */
export const toTenDigitPhone = (value?: string | null) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1);
  }
  return digits;
};

export const sendGtmEvent = (eventName: string, eventData: object = {}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...eventData
    }
  });
};